import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9DCDF",
      d: "M8.09 4.023A5.524 5.524 0 0 0 2.14 8.616l-.06.363a5.92 5.92 0 0 0 .223 2.845l.106.32a7.277 7.277 0 0 0 1.759 2.845l1.436 1.436 4.263 3.488a2.75 2.75 0 0 0 3.483 0l4.262-3.488 1.437-1.436a7.276 7.276 0 0 0 1.758-2.845l.107-.32a5.92 5.92 0 0 0 .223-2.845l-.06-.363a5.524 5.524 0 0 0-8.291-3.829l-1.178.707-1.178-.707a5.524 5.524 0 0 0-2.341-.764Z"
    }, null, -1)
  ]))]))
}
export default { render: render }